import { Money } from '@ap/interface-bspc-core';
import { SellingCost, SellingCostDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class SellingCostBuilder {
    private amount: Money;
    private detail: SellingCostDetail;

    withAmount(amount: Money): this {
        this.amount = amount;
        return this;
    }

    withDetail(detail: SellingCostDetail): this {
        this.detail = detail;
        return this;
    }

    build(): SellingCost {
        return {
            amount: this.amount,
            detail: this.detail
        } as SellingCost;
    }
}

export const aSellingCost = new SellingCostBuilder();
